import React from 'react';
import VirtualList, { Props } from 'react-tiny-virtual-list';

export interface PaginatedVirtualScrollProps extends Partial<Props> {
    height: number;
    itemsPerPage: number;
    totalItems: number;
    pageComponent: React.ComponentType<{ page: number }>;
    itemSize: (index: number) => number;
}

const PaginatedVirtualScroll: React.FC<PaginatedVirtualScrollProps> = ({
    height,
    itemsPerPage,
    totalItems,
    pageComponent: PageComponent,
    itemSize,
    ...props
}) => (
    <VirtualList
        height={height}
        itemCount={totalItems || 1}
        itemSize={itemSize}
        renderItem={({ index: page, style }) => (
            <div key={page} style={style}>
                <PageComponent page={page} />
            </div>
        )}
        {...props}
    />
);

export default PaginatedVirtualScroll;
